const appendQueryString = (href, query, pickParams) => {
    if (!Array.isArray(pickParams) || !(pickParams === null || pickParams === void 0 ? void 0 : pickParams.length))
        return href ? `${href}?${query.toString()}` : '';
    const searchParams = new URLSearchParams();
    pickParams.forEach(param => {
        const value = query.get(param);
        if (value)
            searchParams.set(param, value);
    });
    return href ? `${href}?${searchParams.toString()}` : '';
};
export default appendQueryString;
